__turbopack_context__.v({
  "fieldset": "Fieldset-module-scss-module__RAtsGG__fieldset",
});
